import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Please fill all fields');
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_name', data.admin.name);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Login Form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center p-8 lg:p-16 bg-white">
        <div className="max-w-md mx-auto w-full">
          {/* Logo & Company Name */}
          <div className="mb-12">
            <div className="w-12 h-12 bg-zinc-900 rounded-lg mb-4 flex items-center justify-center">
              <span className="text-white font-bold text-xl">RP</span>
            </div>
            <h2 className="text-2xl font-bold text-zinc-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              RetouchingPix
            </h2>
            <p className="text-zinc-600 mt-2">Admin Portal</p>
          </div>

          <h1 className="text-4xl font-bold text-zinc-900 mb-8" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Welcome Back
          </h1>

          <form onSubmit={handleLogin} className="space-y-6">
            {/* Email Field */}
            <div>
              <Label data-testid="admin-email-label" className="text-sm font-medium mb-2 block">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-zinc-400" />
                <Input
                  data-testid="admin-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="contact@retouchingpix.com"
                  className="pl-10 h-11"
                />
              </div>
            </div>

            {/* Password Field */}
            <div>
              <Label data-testid="admin-password-label" className="text-sm font-medium mb-2 block">Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-zinc-400" />
                <Input
                  data-testid="admin-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="pl-10 h-11"
                />
              </div>
            </div>

            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-zinc-900 text-white hover:bg-zinc-800 font-medium"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </div>
      </div>

      {/* Right Panel - Hero Image */}
      <div className="hidden lg:block lg:w-1/2 bg-zinc-100 relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/3137052/pexels-photo-3137052.jpeg"
          alt="Admin Background"
          className="hero-image"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-zinc-900/40 to-transparent" />
      </div>
    </div>
  );
};

export default AdminLogin;